import type { TermsAndConditionsPage, TermsAndConditionsPageQuery } from '@edwin-group/people-graphql';

import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_TERMS_AND_CONDITIONS_PAGE } from '@edwin-group/people-graphql';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<TermsAndConditionsPageQuery>({
      query: QUERY_TERMS_AND_CONDITIONS_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.termsAndConditionsPage?.data?.attributes as TermsAndConditionsPage,
    error,
  };
};
